module.exports = __webpack_public_path__ + "static/media/intro.cf659dea.mp3";